type SessionInvalidationReason = 'missing_refresh_token' | 'refresh_rejected' | 'rate_limited';

type SessionInvalidationListener = (reason: SessionInvalidationReason) => void;

const listeners = new Set<SessionInvalidationListener>();

export const onSessionInvalidated = (listener: SessionInvalidationListener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const notifySessionInvalidated = (reason: SessionInvalidationReason) => {
  listeners.forEach((listener) => {
    try {
      listener(reason);
    } catch {
      // Listener failures should not block auth cleanup.
    }
  });
};
